module.exports = __webpack_public_path__ + "img/4077d72.jpg";